import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { CotisationProvider, CotisationBanner } from "./CotisationBanner";
import axios from "axios";
import {
  LayoutDashboard,
  Truck,
  Calendar,
  ShoppingBag,
  Receipt,
  CreditCard,
  Users,
  Menu,
  X,
  LogOut,
  ChevronRight,
  Settings,
  UserCheck,
  Store,
  CalendarCheck,
  CalendarX,
  Wallet,
  Image,
  MessageCircle,
  BarChart3,
  UserPlus,
  Building2,
  Shield,
  Lock,
  HelpCircle,
  Share2,
  ClipboardList,
  FileText,
  UtensilsCrossed,
  BookUser,
  PartyPopper,
  ClipboardCheck,
  Mail,
  Award,
  Target,
  PlusCircle,
  Euro,
  Calculator,
  BookOpen,
  Briefcase,
  Leaf,
  Radar,
} from "lucide-react";
import { Button } from "./ui/button";
import { ScrollArea } from "./ui/scroll-area";
import { Avatar, AvatarFallback } from "./ui/avatar";
import NotificationBell from "./NotificationBell";

// Navigation pour les admins et bureau
const adminNavItems = [
  { section: "PILOTAGE", path: "#spil", label: "PILOTAGE", roles: ["admin","bureau","commercial","tresorier","president"] },
  { path: "/dashboard", label: "Tableau de bord", icon: LayoutDashboard, roles: ["admin", "bureau"] },
  { path: "/tableau-association", label: "Bilan de l'association", icon: BarChart3, roles: ["admin", "bureau"] },
  { path: "/kpis-performance", label: "KPIs / Performance", icon: BarChart3, roles: ["admin", "bureau"] },
  { section: "ADHERENTS", path: "#sadh", label: "ADHERENTS", roles: ["admin","bureau","commercial","tresorier","president"] },
  { path: "/avantages", label: "Avantages Collectifs", icon: Share2, roles: ["admin","bureau","commercial","tresorier","president"] },
  { path: "/documents-conformite", label: "Conformite Documents", icon: ClipboardCheck, roles: ["admin", "bureau"] },
  { path: "/food-trucks", label: "Adhérents", icon: Truck, roles: ["admin", "bureau", "commercial"] },
  { path: "/roles", label: "Rôles & Responsabilités", icon: Shield, roles: ["admin", "bureau"] },
  { path: "/blockages", label: "Gestion Blocages", icon: Lock, roles: ["admin", "bureau"] },
  { path: "/annuaire", label: "Annuaire", icon: BookUser, roles: ["admin", "bureau", "benevole"] },
  { path: "/benevoles", label: "Bénévoles", icon: Award, roles: ["admin", "bureau"] },
  { path: "/relances-adherents", label: "Relances adhérents", icon: Mail, roles: ["admin", "bureau"] },
  { path: "/vivier", label: "Vivier d'extras", icon: Users, roles: ["admin", "bureau", "tresorier", "president"] },
  { path: "/annuaire-clients", label: "Annuaire Clients", icon: Users, roles: ["admin", "bureau", "commercial"] },
  { path: "/admin/validations", label: "Validations", icon: UserCheck, roles: ["admin"] },
  { section: "CLIENTS", path: "#scli", label: "CLIENTS", roles: ["admin","bureau","commercial","tresorier","president"] },
  { path: "/crm", label: "CRM Clients", icon: UserPlus, roles: ["admin"] },
  { path: "/dossier-presentation", label: "Dossier de présentation", icon: FileText, roles: ["admin", "bureau", "commercial"] },
  { path: "/appels-offres", label: "Appels d'offres", icon: Briefcase, roles: ["admin", "bureau"] },
  { path: "/veille", label: "Veille marchés", icon: Radar, roles: ["admin", "bureau"] },
  { path: "/prospection", label: "Prospection", icon: Target, roles: ["admin", "bureau"] },
  { path: "/client-accounts", label: "Comptes Clients", icon: UserPlus, roles: ["admin", "bureau"] },
  { section: "EVENEMENTS", path: "#seve", label: "EVENEMENTS", roles: ["admin","bureau","commercial","tresorier","president"] },
  // { path: "/planning", label: "Planning", icon: Calendar, roles: [] },  // masque
  { path: "/placement-direct", label: "Placement Direct", icon: Calendar, roles: ["admin", "bureau"] },
  { path: "/suivi-plannings", label: "Suivi des plannings", icon: BarChart3, roles: ["admin", "bureau", "commercial"] },
  { path: "/hec-planning", label: "Planning HEC", icon: Building2, roles: ["admin", "bureau", "benevole"] },
  { path: "/cout-reel-hec", label: "Coût Réel HEC", icon: Calculator, roles: ["admin"] },
  { path: "/gestion-droits-hec", label: "Droits HEC", icon: Shield, roles: ["admin"] },
  { path: "/sondages", label: "Sondages", icon: ClipboardList, roles: ["admin", "bureau", "commercial"] },
  { section: "FINANCES", path: "#sfin", label: "FINANCES", roles: ["admin","bureau","commercial","tresorier","president"] },
  { path: "/justificatifs-achat", label: "Justificatifs Achat", icon: Receipt, roles: ["admin", "bureau"] },
  { path: "/commissions", label: "Commissions", icon: Receipt, roles: ["admin", "bureau"] },
  { path: "/gestion-commissions", label: "Frais Participation", icon: Euro, roles: ["admin", "bureau"] },
  { path: "/achats-bureau", label: "Achats Bureau", icon: ShoppingBag, roles: ["admin", "bureau"] },
  { path: "/cotisations", label: "Cotisations", icon: Receipt, roles: ["admin", "bureau"] },
  { path: "/paiements-stripe", label: "Paiements Stripe", icon: CreditCard, roles: ["admin"] },
  { path: "/gestion-contrats", label: "Gestion Contrats", icon: FileText, roles: ["admin"] },
  { section: "COMMUNICATION", path: "#scom", label: "COMMUNICATION", roles: ["admin","bureau","commercial","tresorier","president"] },
  { path: "/social-media", label: "Réseaux Sociaux", icon: Share2, roles: ["admin", "bureau", "membre", "benevole"] },
  { path: "/mailing", label: "Mailing", icon: Mail, roles: ["admin", "bureau", "commercial"] },
  { path: "/gallery", label: "Galerie Photos", icon: Image, roles: ["admin", "bureau", "benevole"] },
  { path: "/messages", label: "Messages", icon: MessageCircle, roles: ["admin", "bureau", "commercial", "benevole"] },
  { section: "CONFIGURATION", path: "#scon", label: "CONFIGURATION", roles: ["admin","bureau","commercial","tresorier","president"] },
  { path: "/users", label: "Utilisateurs", icon: Users, roles: ["admin"] },
  { path: "/permissions", label: "Gestion des Droits", icon: Shield, roles: ["admin"] },
  { path: "/badge-generator", label: "Générateur Badge", icon: Award, roles: ["admin", "bureau"] },
  { path: "/guide", label: "Guide", icon: BookOpen, roles: ["admin", "bureau"] },
  { path: "/settings", label: "Paramètres", icon: Settings, roles: ["admin"] },
  { section: "MON ESPACE", path: "#smon", label: "MON ESPACE", roles: ["admin","bureau","commercial","tresorier","president"] },
  { path: "/dashboard-commercial", label: "Mon Dashboard", icon: LayoutDashboard, roles: ["commercial"] },
  { path: "/mon-food-truck", label: "Mon Food Truck", icon: Store, roles: ["bureau"] },
  { path: "/mon-menu", label: "Mon Menu", icon: UtensilsCrossed, roles: ["admin", "bureau"] },
  { path: "/hygiene", label: "Hygiène HACCP", icon: ClipboardCheck, roles: ["admin", "bureau"] },
  { path: "/mes-services", label: "Mes Services", icon: CalendarCheck, roles: ["bureau"] },
  { path: "/mes-propositions", label: "Mes Propositions", icon: FileText, roles: ["bureau"] },
  { path: "/mon-info-hec", label: "Mon Info HEC", icon: Building2, roles: ["admin", "bureau", "membre", "benevole"] },
  { path: "/mes-menus", label: "Mes demandes de menu", icon: UtensilsCrossed, roles: ["admin", "bureau", "commercial", "membre", "benevole", "tresorier", "president"] },
  { path: "/charte-rse", label: "Charte RSE", icon: Leaf, roles: ["admin", "bureau", "commercial", "membre", "benevole", "tresorier", "president"] },
  { path: "/bilan-rse", label: "Bilan RSE", icon: Leaf, roles: ["admin", "bureau", "tresorier", "president"] },
  { path: "/bilans", label: "Bilans Prestations", icon: BarChart3, roles: ["admin", "bureau"] },
  { path: "/commissions", label: "Mes Commissions", icon: Receipt, roles: ["commercial"] },
  { section: "AUTRES", path: "#saut", label: "AUTRES", roles: ["admin","bureau","commercial","tresorier","president"] },
  { path: "/facturation-externe", label: "Facturation Externe", icon: FileText, roles: ["admin"] },
];

// Navigation pour les membres (food trucks)
const memberNavItems = [
  { path: "/avantages", label: "Avantages Collectifs", icon: Share2, roles: ["membre"] },
  { path: "/dashboard", label: "Tableau de bord", icon: LayoutDashboard, roles: ["membre"] },
  { path: "/mon-food-truck", label: "Mon Food Truck", icon: Store, roles: ["membre"] },
  { path: "/mon-menu", label: "Mon Menu", icon: UtensilsCrossed, roles: ["membre"] },
  { path: "/hygiene", label: "Hygiène HACCP", icon: ClipboardCheck, roles: ["membre"] },
  { path: "/proposer-evenement", label: "Proposer un événement", icon: PlusCircle, roles: ["membre"] },
  { path: "/mes-propositions", label: "Mes Propositions", icon: FileText, roles: ["membre"] },
  { path: "/mes-services", label: "Mes Services", icon: CalendarCheck, roles: ["membre"] },
  { path: "/vivier", label: "Vivier d'extras", icon: Users, roles: ["membre"] },
  { path: "/charte-rse", label: "Charte RSE", icon: Leaf, roles: ["membre"] },
  { path: "/bilan-rse", label: "Bilan RSE", icon: Leaf, roles: ["membre"] },
  { path: "/mon-info-hec", label: "Mon Info HEC", icon: Building2, roles: ["membre"] },
  { path: "/mes-paiements", label: "Mes Paiements", icon: Wallet, roles: ["membre"] },
  { path: "/social-media", label: "Réseaux Sociaux", icon: Share2, roles: ["membre"] },
  { path: "/messages", label: "Messages", icon: MessageCircle, roles: ["membre"] },
  { path: "/gallery", label: "Galerie Photos", icon: Image, roles: ["membre"] },
  { path: "/guide", label: "Guide", icon: BookOpen, roles: ["membre"] },
];

// Navigation pour les extras du vivier
const extraNavItems = [
  { path: "/mon-espace-extra", label: "Mon espace extra", icon: UserCheck, roles: ["staff_extra"] },
];

// Navigation pour les clients (accès HEC uniquement)
const clientNavItems = [
  { path: "/hec-planning", label: "Planning HEC", icon: Building2, roles: ["client"] },
];

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [hasHecAccess, setHasHecAccess] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  // Check HEC access for all users (except pure admin)
  useEffect(() => {
    const checkHecAccess = async () => {
      // Pure admin always has access to everything
      if (user?.role === "admin") {
        setHasHecAccess(true);
        return;
      }
      
      // Commercial doesn't need HEC access
      if (user?.role === "commercial") {
        setHasHecAccess(false);
        return;
      }
      
      // For bureau and members, check if they have HEC access enabled
      if ((user?.role === "bureau" || user?.role === "membre") && token) {
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/hec/my-info`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          // If they have any HEC planning with access, show the menu
          setHasHecAccess(response.data && response.data.length > 0);
        } catch (error) {
          setHasHecAccess(false);
        }
      }
    };
    
    if (user) {
      checkHecAccess();
    }
  }, [user, token]);

  // Sélectionner la navigation appropriée selon le rôle
  const getNavItems = () => {
    if (user?.role === "client") return clientNavItems;
    if (user?.role === "staff_extra") return extraNavItems;
    if (user?.role === "membre") return memberNavItems;
    return adminNavItems;
  };
  
  const navItems = getNavItems();
  
  // Filter navigation items based on role AND HEC access
  const filteredNav = navItems.filter((item) => {
    // Check role permission first
    if (!item.roles.includes(user?.role)) return false;
    
    // For "Mon Info HEC", check if user has HEC access (admin always sees it)
    if (item.path === "/mon-info-hec" && user?.role !== "admin" && !hasHecAccess) {
      return false;
    }
    
    return true;
  });

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const NavLink = ({ item, mobile = false }) => {
    const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + "/");
    const Icon = item.icon;

    return (
      <Link
        to={item.path}
        onClick={() => mobile && setSidebarOpen(false)}
        data-testid={`nav-${item.path.slice(1)}`}
        className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 group ${
          isActive
            ? "bg-primary text-white shadow-md"
            : "text-secondary hover:bg-[#F0EBE6] hover:text-primary"
        }`}
      >
        <Icon className="w-5 h-5" strokeWidth={1.5} />
        <span className="font-medium">{item.label}</span>
        {isActive && <ChevronRight className="w-4 h-4 ml-auto" />}
      </Link>
    );
  };

  return (
    <CotisationProvider>
      <div className="min-h-screen bg-[#F9F7F5]">
        {/* Cotisation Warning Banner */}
        <CotisationBanner />
        
        {/* Mobile Header */}
        <header className="lg:hidden fixed top-0 left-0 right-0 z-40 glass border-b border-[#E5E0DC]">
        <div className="flex items-center justify-between px-4 py-3">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setSidebarOpen(true)}
            data-testid="mobile-menu-btn"
            className="text-secondary"
          >
            <Menu className="w-6 h-6" />
          </Button>
          <div className="flex items-center gap-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_fleet-manager-378/artifacts/sum73cxm_image.png" 
              alt="Logo" 
              className="w-10 h-10 object-contain"
            />
            <span className="font-heading font-bold text-primary">FTU</span>
          </div>
          <div className="flex items-center gap-2">
            <NotificationBell />
            <Avatar className="h-9 w-9 border-2 border-primary/20">
              <AvatarFallback className="bg-primary/10 text-primary font-semibold">
                {user?.nom?.charAt(0).toUpperCase()}
              </AvatarFallback>
            </Avatar>
          </div>
        </div>
      </header>

      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black/20 backdrop-blur-sm z-40"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-full w-72 bg-white border-r border-[#E5E0DC] z-50 transform transition-transform duration-300 lg:translate-x-0 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="p-6 border-b border-[#E5E0DC]">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <img 
                  src="https://customer-assets.emergentagent.com/job_fleet-manager-378/artifacts/sum73cxm_image.png" 
                  alt="Food Truck United" 
                  className="w-12 h-12 object-contain"
                />
                <div>
                  <h1 className="font-heading font-bold text-lg text-primary">Food Truck</h1>
                  <p className="text-xs text-secondary font-semibold">United</p>
                </div>
              </div>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => setSidebarOpen(false)}
                className="lg:hidden text-secondary"
              >
                <X className="w-5 h-5" />
              </Button>
            </div>
          </div>

          {/* Navigation */}
          <ScrollArea className="flex-1 p-4">
            <nav className="space-y-2">
              {filteredNav.map((item) => (
                item.section ? (<div key={item.path} className="px-3 pt-5 pb-1 text-[11px] font-semibold tracking-wider text-gray-400 uppercase">{item.section}</div>) : (<NavLink key={item.path} item={item} mobile />) /*__MG__*/
              ))}
            </nav>
          </ScrollArea>

          {/* User Section */}
          <div className="p-4 border-t border-[#E5E0DC]">
            <div className="flex items-center gap-3 mb-4 p-3 bg-[#F9F7F5] rounded-lg">
              <Avatar className="h-10 w-10 border-2 border-primary/20">
                <AvatarFallback className="bg-primary/10 text-primary font-semibold">
                  {user?.nom?.charAt(0).toUpperCase()}
                </AvatarFallback>
              </Avatar>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-secondary truncate">{user?.nom}</p>
                <p className="text-xs text-muted-foreground capitalize">{user?.role}</p>
              </div>
              <div className="hidden lg:block">
                <NotificationBell />
              </div>
            </div>
            <Button
              variant="outline"
              className="w-full justify-start gap-2 text-secondary border-[#E5E0DC] hover:bg-[#F0EBE6] hover:text-primary"
              onClick={handleLogout}
              data-testid="logout-btn"
            >
              <LogOut className="w-4 h-4" />
              Déconnexion
            </Button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="lg:pl-72 pt-16 lg:pt-0 pb-20 lg:pb-0 min-h-screen">
        <div className="p-4 md:p-6 lg:p-8 max-w-7xl mx-auto animate-fade-in">
          {children}
        </div>
      </main>
    </div>
    </CotisationProvider>
  );
}
